import { Location, ViewportScroller } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Link } from 'src/app/model/shared/link';
import { SideMenu } from 'src/app/model/shared/side-menu';
import { ConfigService } from 'src/app/service/config.service';
import { ContentfulService } from 'src/app/service/contentful.service';

import { KnownIssuesContentComponent } from '../../page/group/known-issues/known-issues-content/known-issues-content.component';

declare function leftSideMenu(): any;

@Component({
  selector: 'app-left-side-menu-known-issues',
  templateUrl: './left-side-menu-known-issues.component.html',
  styleUrls: ['./left-side-menu-known-issues.component.scss']
})
export class LeftSideMenuKnownIssuesComponent implements OnInit {
  @Input() pageTitle: string = '';
  @Input() href: string = '';
  @Input() pageName: string = '';

  sideMenu: SideMenu = {} as SideMenu;
  categories: Link[] = [];
  linkMap = new Map();
  subscribeUrl: string = '';

  @ViewChild(KnownIssuesContentComponent)
  knownIssuesContentComponent!: KnownIssuesContentComponent;

  constructor(public configService: ConfigService, private scroller: ViewportScroller, private location: Location, private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    this.sideMenu.links = [];
    this.megaSideMenu();
    if (this.pageTitle === undefined) {
      this.pageTitle = '';
    }
  }

  closeNav() {
    let element: HTMLElement = document.getElementsByClassName('closebtnIAG')[0] as HTMLElement;
    element.click();
  }

  private megaSideMenu() {
    this.sideMenu.links = [];
    const query = { 'fields.name': 'Left Side Menu#KNOWN-ISSUES' };
    this.contentfulService.getMenuContentWithItems(query).then((menuItems) => {
      this.sideMenu.links = menuItems[0]?.fields.jsonData;
      this.processJSONData();
      leftSideMenu();
    });
  }

  processJSONData() {
    this.categories.push(...this.sideMenu.links.filter((link) => link.category === undefined));
    // console.log(this.categories);

    this.categories.forEach((category) => {
      this.linkMap.set(
        category.title,
        this.sideMenu.links.filter((link) => link.category === category.title)
      );
    });
    // console.log(this.linkMap);

    if (this.pageTitle === undefined || this.pageTitle.length == 0) {
      this.pageTitle = this.sideMenu.links[0].pageTitle || '';
      // console.log('Setting known Issue Default Page : ' + this.pageTitle);
    }
    this.sideMenu.links.find((link) => (this.subscribeUrl = link.subscribeUrl));
  }

  setPageTitle(pageTitle: string) {
    this.href = '';
    if (this.knownIssuesContentComponent) {
      this.knownIssuesContentComponent.setPageTitle(pageTitle);
    }
  }

  setPageURL(value: string) {
    this.location.replaceState(value);
  }

  scrollToHref(value: string) {
    this.scroller.scrollToAnchor(value);
    if (value && value.length > 0) {
      this.href = value;
      this.scroller.scrollToAnchor(value);
    }
  }

  scrollToClass(value: string) {
    if (value && value.length > 0) {
      this.href = value;
    }
  }
}
